import { render, staticRenderFns } from "./NsSpinner.vue?vue&type=template&id=4f4e96f0&"
import script from "./NsSpinner.vue?vue&type=script&lang=js&"
export * from "./NsSpinner.vue?vue&type=script&lang=js&"
import style0 from "./NsSpinner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports